import { ApiClient, ApiResponse } from '../client';

export interface ContactFormData {
  nombre: string;
  email: string;
  asunto: string;
  mensaje: string;
  recaptchaToken: string;
}

export interface ContactResponse {
  message: string;
}

export class ContactService {
  private client: ApiClient;

  constructor(client: ApiClient) {
    this.client = client;
  }

  /**
   * Send contact form message
   */
  async sendMessage(data: ContactFormData): Promise<ApiResponse<ContactResponse>> {
    return this.client.post<ContactResponse>('/contact', data);
  }
}
